import { FilePreview } from "../../../components/ui/FilePreview";
import {DOCUMENT_CATEGORIES, FileCategory, FileCategoryModal} from "./FileCategoryModal";
import FileUpload from "./FileUpload";
import { UploadedFileCardList } from "./UploadedFileCardList";
import { useFileUpload } from "../customHooks/useFileUpload";
import {string} from "yup";

export interface CategorizedFiles {
  [key: string]: {
    files: File[];
    previews: string[];
    progress: number[];
    uploadStatus: string[];
  };
}

// FileUploadComponent.tsx
interface FileUploadComponentProps {
  id: string | undefined;
  className?: string;
  documentCategories?: FileCategory[]; // Add this prop
}

export const FileUploadComponent = ({
                                      id,
                                      className,
                                      documentCategories = DOCUMENT_CATEGORIES, // Default to all categories if not specified
                                    }: FileUploadComponentProps) => {
  const {
    fileInputRef,
    showModal,
    setShowModal,
    showImageModal,
    modalImage,
    categorizedFiles,
    handleUploadSectionClick,
    handleCategorySelect,
    handleFileChange,
    handleFileUpload,
    openImageModal,
    closeImageModal,
    setShowImageModal,
  } = useFileUpload({ applicationId: id });

  return (
      <div className={`w-full max-w-md mx-auto md:max-w-full md:m-0 py-4 px-2 ${className}`}>
        <FileUpload
            handleUploadSectionClick={handleUploadSectionClick}
            handleFileChange={handleFileChange}
            fileInputRef={fileInputRef}
        />
        <FileCategoryModal
            showModal={showModal}
            setShowModal={setShowModal}
            handleCategorySelect={handleCategorySelect}
            documentCategories={documentCategories} // Pass categories to modal
        />
        <UploadedFileCardList
            openImageModal={openImageModal}
            handleFileUpload={handleFileUpload}
            categorizedFiles={categorizedFiles}
        />
        <FilePreview
            modalImage={modalImage}
            closeModal={closeImageModal}
            showImageModal={showImageModal}
            setShowImageModal={setShowImageModal}
        />
      </div>
  );
};

